// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-medium":"#5e5e5e","col-2":"_9e1uifG _1npT0qO xdi1PiT _2CDDqOE"};